// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Paging from "./Paging";
import RegistrationField from "entity/RegistrationField";
import SocialEvent, { processSocialEvent, processSocialEventArray } from "entity/SocialEvent";
import SocialEventEmail from "entity/SocialEventEmail";
import SocialEventEmailType from "enums/SocialEventEmailType";
import UserRegistration, { processUserRegistration, processUserRegistrationArray } from "entity/UserRegistration";
import UserRegistrationValue from "entity/UserRegistrationValue";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class SocialEventController extends RestController {

    /*
     Add registration field
     */

    addRegistrationField(socialEventId: string, field: RegistrationField): Promise<RegistrationField> {
        let request = new RestRequest("/api/v1/event/registration/field", "POST", field, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<RegistrationField>;
    }

    /*
     Confirm registrations
     */

    confirmRegistrations(socialEventId: string, all: boolean, userIds: string[]): Promise<number> {
        let request = new RestRequest("/api/v1/event/registration/confirm", "POST", userIds, { socialEventId: socialEventId, all: all });
        return this.request(request, null) as Promise<number>;
    }

    /*
     Create an event
     */

    createEvent(event: SocialEvent): Promise<SocialEvent> {
        let request = new RestRequest("/api/v1/event", "POST", event, undefined);
        return this.request(request, processSocialEvent) as Promise<SocialEvent>;
    }

    /*
     Delete event
     */

    deleteEvent(socialEventId: string): Promise<void> {
        let request = new RestRequest("/api/v1/event", "DELETE", null, { socialEventId: socialEventId });
        return this.requestVoid(request);
    }

    /*
     Get registrations
     */

    downloadRegistrations(socialEventId: string): Promise<string> {
        let request = new RestRequest("/api/v1/event/registration/download", "GET", null, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<string>;
    }

    /*
     Get event
     */

    getEvent(socialEventId: string): Promise<SocialEvent> {
        let request = new RestRequest("/api/v1/event/" + socialEventId + "", "GET", null, undefined);
        return this.request(request, processSocialEvent) as Promise<SocialEvent>;
    }

    /*
     Get event by event link
     */

    getEventByLink(eventLink: string): Promise<SocialEvent> {
        let request = new RestRequest("/api/v1/event/link/get", "POST", eventLink, undefined);
        return this.request(request, processSocialEvent) as Promise<SocialEvent>;
    }

    /*
     Get event email template
     */

    getEventEmailTemplate(type: SocialEventEmailType): Promise<string> {
        let request = new RestRequest("/api/v1/event/email/template", "GET", null, { type: type });
        return this.request(request, null) as Promise<string>;
    }

    /*
     Get event emails
     */

    getEventEmails(socialEventId: string): Promise<SocialEventEmail[]> {
        let request = new RestRequest("/api/v1/event/email", "GET", null, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<SocialEventEmail[]>;
    }

    /*
     Get events
     */

    getEvents(onlyMine: boolean, pastEvents: boolean, text?: string, page?: Paging): Promise<SocialEvent[]> {
        const queryParams: QueryParams = { onlyMine: onlyMine, pastEvents: pastEvents };
        if (text !== undefined) {
          queryParams.text = text;
        }
        let request = new RestRequest("/api/v1/event", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialEventArray) as Promise<SocialEvent[]>;
    }

    /*
     Get registration with related event and guest user tokens
     */

    getRegistration(registrationId: string): Promise<UserRegistration> {
        let request = new RestRequest("/api/v1/event/registration/" + registrationId + "", "GET", null, undefined);
        return this.request(request, processUserRegistration) as Promise<UserRegistration>;
    }

    /*
     Get registration count
     */

    getRegistrationCount(socialEventId: string, page?: Paging): Promise<number> {
        let request = new RestRequest("/api/v1/event/registration/count", "GET", null, { socialEventId: socialEventId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<number>;
    }

    /*
     Get registration fields
     */

    getRegistrationFields(socialEventId: string): Promise<RegistrationField[]> {
        let request = new RestRequest("/api/v1/event/registration/field", "GET", null, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<RegistrationField[]>;
    }

    /*
     Get registrations
     */

    getRegistrations(socialEventId: string, text?: string, page?: Paging): Promise<UserRegistration[]> {
        const queryParams: QueryParams = { socialEventId: socialEventId };
        if (text !== undefined) {
          queryParams.text = text;
        }
        let request = new RestRequest("/api/v1/event/registration", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processUserRegistrationArray) as Promise<UserRegistration[]>;
    }

    /*
     Check if event link is available
     */

    isLinkAvailable(eventLink: string): Promise<boolean> {
        let request = new RestRequest("/api/v1/event/link", "POST", eventLink, undefined);
        return this.request(request, null) as Promise<boolean>;
    }

    /*
     Move registration field
     */

    moveRegistrationField(socialEventId: string, id: number, position: number): Promise<RegistrationField> {
        let request = new RestRequest("/api/v1/event/registration/field/move", "PATCH", null, { socialEventId: socialEventId, id: id, position: position });
        return this.request(request, null) as Promise<RegistrationField>;
    }

    /*
     Remove registration field
     */

    removeRegistrationField(socialEventId: string, id: number): Promise<void> {
        let request = new RestRequest("/api/v1/event/registration/field", "DELETE", null, { socialEventId: socialEventId, id: id });
        return this.requestVoid(request);
    }

    /*
     Save event email
     */

    saveEventEmail(socialEventId: string, email: SocialEventEmail): Promise<SocialEventEmail> {
        let request = new RestRequest("/api/v1/event/email", "POST", email, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<SocialEventEmail>;
    }

    /*
     Save event email
     */

    saveEventEmails(socialEventId: string, emails: SocialEventEmail[]): Promise<SocialEventEmail[]> {
        let request = new RestRequest("/api/v1/event/emails", "POST", emails, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<SocialEventEmail[]>;
    }

    /*
     Save registration
     */

    saveRegistration(socialEventId: string, values: UserRegistrationValue[]): Promise<string> {
        let request = new RestRequest("/api/v1/event/registration/mine", "POST", values, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<string>;
    }

    /*
     Add registration field
     */

    saveRegistrationFields(socialEventId: string, fields: RegistrationField[]): Promise<RegistrationField[]> {
        let request = new RestRequest("/api/v1/event/registration/field/save", "POST", fields, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<RegistrationField[]>;
    }

    /*
     Send registration confirmation email
     */

    sendTestEmail(socialEventId: string, type: SocialEventEmailType, email?: string): Promise<void> {
        const queryParams: QueryParams = { socialEventId: socialEventId, type: type };
        if (email !== undefined) {
          queryParams.email = email;
        }
        let request = new RestRequest("/api/v1/event/registration/confirmation/email", "POST", null, queryParams);
        return this.requestVoid(request);
    }

    /*
     Transfer registration info to signed in user
     */

    transferRegistration(registrationId: string): Promise<void> {
        let request = new RestRequest("/api/v1/event/registration/" + registrationId + "/transfer", "POST", null, undefined);
        return this.requestVoid(request);
    }

    /*
     Create an event
     */

    updateEvent(event: SocialEvent): Promise<SocialEvent> {
        let request = new RestRequest("/api/v1/event", "PATCH", event, undefined);
        return this.request(request, processSocialEvent) as Promise<SocialEvent>;
    }

    /*
     Update registration field
     */

    updateRegistrationField(socialEventId: string, field: RegistrationField): Promise<RegistrationField> {
        let request = new RestRequest("/api/v1/event/registration/field", "PATCH", field, { socialEventId: socialEventId });
        return this.request(request, null) as Promise<RegistrationField>;
    }

}
